import { HttpInterceptorFn } from '@angular/common/http';

import { environment } from '../../environments/environment';

export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const language = localStorage.getItem('qci-portal-language') ?? environment.defaultLanguage;

  return next(
    req.clone({
      setHeaders: {
        'Accept-Language': language,
      },
    }),
  );
};
